export type PaletteGroup =
  | 'recents'
  | 'commands'
  | 'pages'
  | 'inventory'
  | 'leads'
  | 'invoices'
  | 'clients'
  | 'transport'

export type PaletteAction =
  | { kind: 'navigate'; path: string }
  | { kind: 'external'; href: string }
  | { kind: 'scope'; insert: string }
  | { kind: 'clock-in' }
  | { kind: 'clock-out' }
  | { kind: 'ask'; seed?: string }
  | { kind: 'new-lead' }
  | { kind: 'decode-vin' }
  | { kind: 'price' }

export interface PaletteItem {
  id: string
  group: PaletteGroup
  title: string
  subtitle?: string
  slash?: string
  chip?: string
  chipColor?: 'default' | 'secondary' | 'info'
  action: PaletteAction
}

export const PALETTE_GROUP_LABEL: Record<PaletteGroup, string> = {
  recents: 'Recent',
  commands: 'Commands',
  pages: 'Pages',
  inventory: 'Inventory',
  leads: 'Leads',
  invoices: 'Invoices',
  clients: 'Clients',
  transport: 'Transport',
}
